//BITE MENU
import LearningPlanMenu from '../components/menus/learningPlan/LearningPlanMenu';//eslint-disable-line import/no-named-as-default

//BITES
import ScenarioBite from '../components/bites/ScenarioBite/ScenarioBite';//eslint-disable-line import/no-named-as-default

//BITES
export const BITE_TYPE_SCENARIO = "Scenario";
export const COMPONENT_SCENARIO_BITE = ScenarioBite;

//SCREENS

import ScenarioScreen from '../components/screens/scenarioScreen/ScenarioScreen'; //eslint-disable-line import/no-named-as-default
import ScrollScreen from '../components/screens/scrollScreen/ScrollScreen'; //eslint-disable-line import/no-named-as-default
import TabbedScreen from '../components/screens/tabbedScreen/TabbedScreen'; //eslint-disable-line import/no-named-as-default
import TitleScreen from '../components/screens/titleScreen/TitleScreen'; //eslint-disable-line import/no-named-as-default
import TitleScreenManager from '../components/screens/titleScreen/TitleScreenManager'; //eslint-disable-line import/no-named-as-default
import TitleScreenImageBased from '../components/screens/titleScreen/TitleScreenImageBased'; //eslint-disable-line import/no-named-as-default

import AccordionScreen from '../components/screens/accordionScreen/AccordionScreen'; //eslint-disable-line import/no-named-as-default
import SliderScreen from '../components/screens/sliderScreen/SliderScreen';  //eslint-disable-line import/no-named-as-default
import HotspotScreen from '../components/screens/hotspotScreen/HotspotScreen';  //eslint-disable-line import/no-named-as-default
import VideoScreen from '../components/screens/videoScreen/VideoScreen';  //eslint-disable-line import/no-named-as-default
import VideoMobileScreen from '../components/screens/videoScreen/VideoMobileScreen';  //eslint-disable-line import/no-named-as-default
import ResourcesScrollScreen from '../components/screens/resourcesScrollScreen/ResourcesScrollScreen'; //eslint-disable-line import/no-named-as-default

import ToolTip from '../components/objects/tooltip/ToolTip';//eslint-disable-line import/no-named-as-default
import KpiDashboard from '../components/objects/kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import BadgeDashboard from '../components/objects/badges/BadgeDashboard';//eslint-disable-line import/no-named-as-default

import ScoreIntroduction from '../components/objects/kpi/ScoreIntroduction';//eslint-disable-line import/no-named-as-default
import KpiOverview from '../components/objects/kpi/KpiOverview';//eslint-disable-line import/no-named-as-default
import KpiGraphResults from '../components/objects/kpi/KpiGraphResults';//eslint-disable-line import/no-named-as-default
import KpiResultsList from '../components/objects/kpi/KpiResultsList';//eslint-disable-line import/no-named-as-default

import ConversationDialog from '../components/objects/conversationDialog/ConversationDialog';//eslint-disable-line import/no-named-as-default
import CharacterSpeak from '../components/objects/conversationDialog/CharacterSpeak';//eslint-disable-line import/no-named-as-default
import LearnerSpeak from '../components/objects/conversationDialog/LearnerSpeak';//eslint-disable-line import/no-named-as-default
import NarratorSpeak from '../components/objects/conversationDialog/NarratorSpeak';//eslint-disable-line import/no-named-as-default
import Text from '../components/objects/text/Text';//eslint-disable-line import/no-named-as-default
import MultipeChoice from '../components/objects/multipleChoice/MultipleChoice';
import SingleAnswer from '../components/objects/multipleChoice/singleAnswer/SingleAnswer';
import MultipleAnswer from '../components/objects/multipleChoice/multipleAnswer/MultipleAnswer';
import ConversationSingleAnswer from '../components/objects/multipleChoice/conversationSingleAnswer/ConversationSingleAnswer';
import GridChoice from '../components/objects/multipleChoice/gridChoice/GridChoice';
import SwipeHorizontal from '../components/objects/swipeHorizontal/SwipeHorizontal';
import Video from '../components/objects/video/Video';
import VimeoVideo from '../components/objects/video/VimeoVIdeo';//eslint-disable-line import/no-named-as-default
import ReactVideoPlayer from '../components/objects/video/ReactVideoPlayer';//eslint-disable-line import/no-named-as-default
import Link  from '../components/objects/link/Link.js';//eslint-disable-line import/no-named-as-default
import Document  from '../components/objects/document/Document.js';//eslint-disable-line import/no-named-as-default
import Image  from '../components/objects/image/Image.js';//eslint-disable-line import/no-named-as-default
import LibraryImage  from '../components/objects/image/LibraryImage.js';//eslint-disable-line import/no-named-as-default
import TheEnd from '../components/objects/theEnd/TheEnd';//eslint-disable-line import/no-named-as-default
import BadgeOverview from '../components/objects/badges/BadgeOverview';//eslint-disable-line import/no-named-as-default
import AwardBadge from '../components/objects/badges/AwardBadge';//eslint-disable-line import/no-named-as-default
import VimeoPlayer from '../components/objects/video/VimeoPlayer';//eslint-disable-line import/no-named-as-default
import VideoPlayer from '../components/objects/video/VideoPlayer';//eslint-disable-line import/no-named-as-default
import VideoJsInlinePlayer from '../components/objects/video/VideoJsInlinePlayer';//eslint-disable-line import/no-named-as-default
import VideoJsPlayer from '../components/objects/video/VideoJsPlayer';//eslint-disable-line import/no-named-as-default

import ShortResponse from '../components/objects/shortResponse/ShortResponse';//eslint-disable-line import/no-named-as-default
import PrintResponses from '../components/objects/shortResponse/PrintResponses';//eslint-disable-line import/no-named-as-default
//RESOURCES
import ResourcesDocumentLink from '../components/objects/resourceLinks/ResourceDocumentLink';
import ResourcesImageLink from '../components/objects/resourceLinks/ResourceImageLink';
import ResourcesScreenLink from '../components/objects/resourceLinks/ResourceScreenLink';
import ResourcesUrlLink from '../components/objects/resourceLinks/ResourceUrlLink';
import ResourcesVideoLink from '../components/objects/resourceLinks/ResourceVideoLink';


//MENUS
export const MENU_TYPE_LINEAR_LEARNING_PLAN = "linear_learning_plan";
export const MENU_TYPE_OPEN_LEARNING_PLAN = "open_learning_plan";
export const MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN = "first_any_last_learning_plan";
export const MENU_TYPE_PERSONAL_LEARNING_PLAN = "personalised_learning_plan";
export const COMPONENT_LEARNING_PLAN = LearningPlanMenu;

//SCREENS

export const SCREEN_TYPE_SCENARIO = "scenario";
export const COMPONENT_SCENARIO_SCREEN = ScenarioScreen;

export const SCREEN_TYPE_TITLE = "title_screen";
export const COMPONENT_TITLE_SCREEN = TitleScreenManager;

export const SCREEN_SUB_TYPE_TITLE_STANDARD = "standard";
export const COMPONENT_SCREEN_SUB_TYPE_TITLE_STANDARD = TitleScreen;
export const SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = "image_based";
export const COMPONENT_SCREEN_SUB_TYPE_TITLE_IMAGE_BASED = TitleScreenImageBased;

export const SCREEN_TYPE_TABBED = "tabbed_content";
export const COMPONENT_TABBED_SCREEN = TabbedScreen;

export const SCREEN_TYPE_SCROLL = "content";
export const COMPONENT_SCROLL_SCREEN = ScrollScreen;

export const SCREEN_TYPE_SLIDER = "slider";
export const COMPONENT_SLIDER_SCREEN = SliderScreen;

export const SCREEN_TYPE_HOTSPOT = "hotspots";
export const COMPONENT_HOTSPOT_SCREEN = HotspotScreen;

export const SCREEN_TYPE_VIDEO = "video";
export const COMPONENT_VIDEO_SCREEN = VideoScreen;

export const COMPONENT_RESOUCES_SCROLL_SCREEN = ResourcesScrollScreen;

//MOBILE SCREENS
export const SCREEN_TYPE_ACCORDION = "accordion";
export const COMPONENT_ACCORDION_SCREEN = AccordionScreen;
export const COMPONENT_VIDEO_MOBILE_SCREEN = VideoMobileScreen;

//objects

export const COMPONENT_TOOLTIP_OBJECT = ToolTip;

export const COMPONENT_KPI_DASHBOARD_OBJECT = KpiDashboard;
export const COMPONENT_BADGE_DASHBOARD_OBJECT = BadgeDashboard;

export const CONVERSATION_DIALOG = "dialog";
export const COMPONENT_CONVERSATION_DIALOG = ConversationDialog;

export const CHARACTER_SPEAK = "character";
export const COMPONENT_CHARACTER_SPEAK = CharacterSpeak;

export const LEARNER_SPEAK = "learner";
export const COMPONENT_LEARNER_SPEAK = LearnerSpeak;

export const NARRATOR_SPEAK = "narrator";
export const COMPONENT_NARRATOR_SPEAK = NarratorSpeak;

export const TEXT = "text";
export const COMPONENT_TEXT = Text;

export const SCORE_INTRODUCTION = "score_introduction";
export const COMPONENT_SCORE_INTRODUCTION = ScoreIntroduction;

export const KPI_OVERVIEW = "objectives_overview";
export const COMPONENT_KPI_OVERVIEW = KpiOverview;

export const MULTIPLE_CHOICE = "multiple_choice";

export const COMPONENT_MULTIPLE_CHOICE = MultipeChoice;

export const SINGLE_ANSWER = "multiple_choice_select_one";
export const COMPONENT_SINGLE_ANSWER = SingleAnswer;

export const MULTIPLE_ANSWER = "multiple_choice_select_many";
export const COMPONENT_MULTIPLE_ANSWER = MultipleAnswer;

export const CONVERSATION_CHOICE = "conversation_choice";
export const COMPONENT_CONVERSATION_CHOICE = MultipeChoice;

export const CONVERSATION_SINGLE_ANSWER = "conversation_choice_select_one";

export const COMPONENT_CONVERSATION_SINGLE_ANSWER = ConversationSingleAnswer;


export const CONVERSATION_MULTIPLE_ANSWER = "conversation_choice_select_many";
export const COMPONENT_CONVERSATION_MULTIPLE_ANSWER = MultipleAnswer;

export const GRID_CHOICE = "grid_choice";

export const COMPONENT_GRID_CHOICE = MultipeChoice;

export const GRID_SINGLE_ANSWER = "grid_choice_select_one";
export const COMPONENT_GRID_SINGLE_ANSWER = GridChoice;

export const SWIPE_HORIZONTAL = "swipe_left_or_right";

export const COMPONENT_SWIPE_HORIZONTAL = SwipeHorizontal;

export const VIDEO = "video";
export const COMPONENT_VIDEO = Video;


export const VIMEO_VIDEO = "vimeo";
export const COMPONENT_VIMEO_VIDEO = VimeoPlayer;

export const YOUTUBE_VIDEO = "youtube";
export const COMPONENT_YOUTUBE = VideoPlayer;

export const MP4_VIDEO = "mp4";
export const COMPONENT_MP4 = VideoJsInlinePlayer;

export const VIMEO_SUB_VIDEO = "vimeo";
export const COMPONENT_SUB_VIMEO_VIDEO = VimeoVideo;

export const YOUTUBE_SUB_VIDEO = "youtube";
export const COMPONENT_SUB_YOUTUBE = ReactVideoPlayer;

export const MP4_SUB_VIDEO = "mp4";
export const COMPONENT_SUB_MP4 = VideoJsPlayer;

export const LINK = 'link';
export const COMPONENT_LINK = Link;

export const DOCUMENT = 'document';
export const COMPONENT_DOCUMENT = Document;

export const IMAGE = 'image';
export const COMPONENT_IMAGE = Image;

export const LIBRARY_IMAGE = 'library_image';
export const COMPONENT_LIBRARY_IMAGE = LibraryImage;

export const KPI_GRAPH_RESULTS = 'graph_results';
export const COMPONENT_KPI_GRAPH_RESULTS = KpiGraphResults;

export const KPI_RESULTS_LIST = 'results_list';
export const COMPONENT_KPI_RESULTS_LIST = KpiResultsList;

export const THE_END = 'the_end';
export const COMPONENT_THE_END = TheEnd;

export const BADGE_OVERVIEW = 'badge_overview';
export const COMPONENT_BADGE_OVERVIEW = BadgeOverview;

export const AWARD_BADGE = 'award_badge';
export const COMPONENT_AWARD_BADGE = AwardBadge;

export const SHORT_RESPONSE = 'short_response';
export const COMPONENT_SHORT_RESPONSE = ShortResponse;

export const PRINT_RESPONSES = 'print_responses';
export const COMPONENT_PRINT_RESPONSES = PrintResponses;

//Resources
export const RESOURCE_DOCUMENT_LINK = 'document';
export const COMPONENT_RESOURCE_DOCUMENT_LINK = ResourcesDocumentLink;

export const RESOURCE_IMAGE_LINK = 'image';
export const COMPONENT_RESOURCE_IMAGE_LINK = ResourcesImageLink;

export const RESOURCE_SCREEN_LINK = 'screen';
export const COMPONENT_RESOURCE_SCREEN_LINK = ResourcesScreenLink;

export const RESOURCE_URL_LINK = 'link';
export const COMPONENT_RESOURCE_URL_LINK = ResourcesUrlLink;

export const RESOURCE_VIDEO_LINK = 'video';
export const COMPONENT_RESOURCE_VIDEO_LINK = ResourcesVideoLink;

export const MULTIPLE_CHOICE_SINGLE_ANSWER_LABEL = "Multiple Choice - Select One";
export const MULTIPLE_CHOICE_MULTIPLE_ANSWER_LABEL = "Multiple Choice - Select Many";
export const CONVERSATION_SINGLE_ANSWER_LABEL = 'Conversation Choice';
export const GRID_CHOICE_LABEL = "Grid Choice";
export const SWIPE_HORIZONTAL_LABEL = "Swipe Left or Right";
export const SHORT_RESPONSE_LABEL = "Short Response";


/** WEBPACK FOOTER **
 ** ./src/constants/componentConstants.js
 **/